<template>
<div class="chapter">
<div class="inner_page">
<h1 class="plm_hd"><a href="#/Text/NSBT_BibTheol_contents">Abbreviations</a></h1>
<p class="abb_fo">4Q175 – <em class="italic">4QTestimonia</em></p>
<p class="abb_fo">4Q375 – <em class="italic">4QApocryphon of Moses</em>a</p>
<p class="abb_fo">4Q500 – <em class="italic">4QBenediction</em></p>
<p class="abb_fo">4QFlor. – <em class="italic">4QFlorilegium</em></p>
<p class="abb_fo">4QMMT – <em class="italic">4QHalakhic Letter</em></p>
<p class="abb_fo">4QpPs<span class="sup_roman">a</span> – <em class="italic">4QPsalms Pesher</em>a</p>
<p class="abb_fo">AB – Anchor Bible</p>
<p class="abb_fo">AnBib – Analecta biblica</p>
<p class="abb_fo">ANTC – Abingdon New Testament Commentaries</p>
<p class="abb_fo">AOTC – Apollos Old Testament Commentary</p>
<p class="abb_fo"><em class="italic">Bar. – Baruch</em></p>
<p class="abb_fo"><em class="italic">BBR – Bulletin for Biblical Research</em></p>
<p class="abb_fo">BDAG – W. Bauer, F. W. Danker, W. F. Arndt and F. W. Gingrich, <em class="italic">A Greek–English Lexicon of the New Testament and Other Early Christian Literature</em>, 3rd edn, Chicago: University of Chicago Press, 2000</p>
<p class="abb_fo">BDF – F. Blass, A. Debrunner and R. W. Funk, <em class="italic">A Greek Grammar of the New Testament and Other Early Christian Literature</em>,<em class="italic"> </em>Chicago: University of Chicago Press, 1961</p>
<p class="abb_fo">BECNT – Baker Exegetical Commentary on the New Testament</p>
<p class="abb_fo"><em class="italic">Bib – Biblica</em></p>
<p class="abb_fo"><em class="italic">BibInt – Biblical Interpretation</em></p>
<p class="abb_fo"><em class="italic">BLE – Bulletin de littérature ecclésiastique</em></p>
<p class="abb_fo"><em class="italic">BSac – Bibliotheca sacra</em></p>
<p class="abb_fo">BTCB – Brazos Theological Commentary on the Bible</p>
<p class="abb_fo">BZNW – Beihefte zur Zeitschrift für die Neutestamentliche Wissenschaft</p>
<p class="abb_fo"><em class="italic">CBQ – Catholic Biblical Quarterly</em></p>
<p class="abb_fo"><em class="italic">CD-A</em> – <em class="italic">Damascus Document</em>a</p>
<p class="abb_fo"><em class="italic">CJT – Canadian Journal of Theology</em></p>
<p class="abb_fo"><em class="italic">CTR – Criswell Theological Review</em></p>
<p class="abb_fo"><em class="italic">CurBR</em> – <em class="italic">Currents in Biblical Research</em></p>
<p class="abb_fo"><em class="italic">DSD – Dead Sea Discoveries</em></p>
<p class="abb_fo">EBC – Expositor’s Bible Commentary</p>
<p class="abb_fo"><em class="italic">EDEJ – The Eerdmans Dictionary of Early Judaism</em>, ed. J. J. Collins and D. C. Harlow, Grand Rapids: Eerdmans, 2010</p>
<p class="abb_fo"><span class="smallcaps">esv</span> – English Standard Version</p>
<p class="abb_fo"><em class="italic">ETL – Ephemerides theologicae lovanienses</em></p>
<p class="abb_fo"><em class="italic">ExAud – Ex Auditu</em></p>
<p class="abb_fo"><em class="italic">Exch – Exchange</em></p>
<p class="abb_fo"><em class="italic">HvTSt – Hervormde Teologiese Studies</em></p>
<p class="abb_fo">ICC – International Critical Commentary</p>
<p class="abb_fo"><em class="italic">JBL – Journal of Biblical Literature</em></p>
<p class="abb_fo"><em class="italic">JETS – Journal of the Evangelical Theological Society</em></p>
<p class="abb_fo">JPTS – Journal of Pentecostal Theology Supplement Series</p>
<p class="abb_fo"><em class="italic">JSNT</em> – <em class="italic">Journal for the Study of the New Testament</em></p>
<p class="abb_fo">JSNTSup – Journal for the Study of the New Testament Supplement Series</p>
<p class="abb_fo"><em class="italic">JSPL – Journal for the Study of Paul and His Letters</em></p>
<p class="abb_fo">JSPSup – Journal for the Study of the Pseudepigrapha Supplement Series</p>
<p class="abb_fo"><em class="italic">JSS – Journal of Semitic Studies</em></p>
<p class="abb_fo"><em class="italic">JTI – Journal for Theological Interpretation</em></p>
<p class="abb_fo"><em class="italic">Jub. – Jubilees</em></p>
<p class="abb_fo"><em class="italic">L.A.B.</em> – <em class="italic">Liber antiquitatum biblicarum</em></p>
<p class="abb_fo">LNTS – The Library of New Testament Studies</p>
<p class="abb_fo"><em class="italic">LW</em> – <em class="italic">Luther’s Works</em>, ed. J. Pelikan, St. Louis: Concordia, 1963</p>
<p class="abb_fo"><span class="smallcaps">lxx – </span>Septuagint</p>
<p class="abb_fo"><span class="smallcaps">mt</span> – Masoretic Text</p>
<p class="abb_fo"><em class="italic">Mart. Ascen. Isa. – Martyrdom and Ascension of Isaiah</em></p>
<p class="abb_fo">N/A – not applicable</p>
<p class="abb_fo">NAC – New American Commentary</p>
<p class="abb_fo">NB – nota bene (note well; observe carefully)</p>
<p class="abb_fo"><em class="italic">Neot</em> – <em class="italic">Neotestamentica</em></p>
<p class="abb_fo"><span class="smallcaps">nets</span> – New English Translation of the Septuagint</p>
<p class="abb_fo">NICNT – New International Commentary on the New Testament</p>
<p class="abb_fo">NIGTC – New International Greek Testament Commentary</p>
<p class="abb_fo"><span class="smallcaps">nivuk</span> – New International Version (anglicized edition)</p>
<p class="abb_fo"><em class="italic">NovT – Novum Testamentum</em></p>
<p class="abb_fo">NovTSup – Supplements to Novum Testamentum</p>
<p class="abb_fo"><span class="smallcaps">nrsva</span> – New Revised Standard Version, Anglicized</p>
<p class="abb_fo">NSBT – New Studies in Biblical Theology</p>
<p class="abb_fo">NT – New Testament</p>
<p class="abb_fo"><em class="italic">NTS – New Testament Studies</em></p>
<p class="abb_fo">OT – Old Testament</p>
<p class="abb_fo">PCNT – Paideia Commentaries on the New Testament</p>
<p class="abb_fo">PNTC – Pillar New Testament Commentary</p>
<p class="abb_fo"><em class="italic">PRSt – Perspectives in Religious Studies</em></p>
<p class="abb_fo"><em class="italic">Pss Sol. – Psalms of Solomon</em></p>
<p class="abb_fo">RB – rewritten Bible</p>
<p class="abb_fo"><em class="italic">RTR – The Reformed Theological Review</em></p>
<p class="abb_fo"><em class="italic">SBJT</em> – <em class="italic">Southern Baptist Journal of Theology</em></p>
<p class="abb_fo">SBLDS – Society of Biblical Literature Dissertation Series</p>
<p class="abb_fo">SIS – summary/summaries of Israel’s story</p>
<p class="abb_fo"><em class="italic">SJT – Scottish Journal of Theology</em></p>
<p class="abb_fo">SNTSMS – Society for New Testament Studies Monograph Series</p>
<p class="abb_fo">s.v. – sub verbo (under the word)</p>
<p class="abb_fo"><em class="italic">TDNT – Theological Dictionary of the New Testament</em>, ed. G. Kittel and G. Friedrich; tr. G. W. Bromiley, 10 vols, Grand Rapids: Eerdmans, 1964–76</p>
<p class="abb_fo"><em class="italic">Tg. Jon. – Targum Jonathan</em></p>
<p class="abb_fo"><em class="italic">TJ – Trinity Journal</em></p>
<p class="abb_fo">TOTC – Tyndale Old Testament Commentary</p>
<p class="abb_fo">tr. – translated, translation</p>
<p class="abb_fo"><em class="italic">TynBul – Tyndale Bulletin</em></p>
<p class="abb_fo">WBC – Word Biblical Commentary</p>
<p class="abb_fo"><em class="italic">WTJ – Westminster Theological Journal</em></p>
<p class="abb_fo">WUNT – Wissenschaftliche Untersuchungen zum Neuen Testament</p>
<p class="abb_fo">ZECNT – Zondervan Exegetical Commentary on the New Testament</p>
<p class="abb_fo"><em class="italic">ZNW – Zeitschrift für die neutestamentliche Wissenschaft und die Kunde der älteren Kirche </em></p>
<p class="fo"><em class="italic"></em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// NSBT_BibTheol_abbrev.vue?52ec079f